import PropTypes from 'prop-types';
import {css} from 'styled-components/macro';
import {hexToRgb} from '../utils/colors';

// TODO REQS breakpoints for login page and overlays?
export const breakpoints = {
  md: 992,
  lg: 1200,
};

export const mediaQueries = key => style => `@media (min-width: ${breakpoints[key]}px) {${style}}`;

/**
 * Sets width and defaults to 'fill'
 * @param width
 * @return {string}
 */
export const fill = width => (width && width !== 'fill')
  ? `width: ${width};`
  : 'width: 100%; width: -moz-available; width: -webkit-fill-available; width: fill-available; width: stretch;';

/**
 * Sets max-width and defaults to 'fill'
 * @param width
 * @return {string}
 */
export const fillMaxWidth = width => (width && width !== 'fill')
  ? `max-width: ${width};`
  : 'max-width: 100%; max-width: -moz-available; max-width: -webkit-fill-available; max-width: fill-available; max-width: stretch;';

/**
 * Sets height and defaults to 'fill'
 * @param height
 * @return {string}
 */
export const fillHeight = height => height
  ? `height: ${height};`
  : 'height: 100%; box-sizing: border-box;';

/**
 * Sets max height and defaults to 'fill'
 * @param height
 * @return {string}
 */
export const fillMaxHeight = height => height
  ? `max-height: ${height};`
  : 'max-height: 100%; box-sizing: border-box;';

/**
 * Mapping of UX Row, Column, and Layout inputs to flex values.
 * @type {{"space between": string, stretch: string, "space around": string, middle: string, top: string, left: string, bottom: string, center: string, right: string}}
 */
export const flexMap = {
  left: 'flex-start',
  top: 'flex-start',
  right: 'flex-end',
  bottom: 'flex-end',
  'space between': 'space-between',
  'space around': 'space-around',
  middle: 'center',
  center: 'center',
  stretch: 'stretch',
};

/**
 * Mapping of wrap true/false to flex-wrap:wrap,nowrap.
 * @param props
 * @param [props.wrap]
 * @return {string}
 */
export const flexWrap = props => props.wrap != false // eslint-disable-line eqeqeq
  && '-webkit-flex-wrap: wrap;flex-wrap: wrap;'
  || '-webkit-flex-wrap: nowrap;flex-wrap: nowrap;';

export const layoutAttribute = {
  propTypes: PropTypes.shape({
    /**
     * Grow Ratio, flex-grow, defaults to 0
     */
    grow: PropTypes.number,
    /**
     * Grow Ratio, flex-shrink
     */
    shrink: PropTypes.number,
    /**
     * Vertical/Horizontal Alignment (Depending if in Column or Row), align-self, see cssUtils.flexWrap for mapping // ETODO Link to flexWrap
     */
    align: PropTypes.oneOf(['left', 'top', 'right', 'bottom', 'middle', 'center', 'stretch', 'space between', 'space around']),
  }),
  css: props => `
  ${props && props.layout && props.layout.align ? `align-self: ${flexMap[props.layout.align]};` : ''};
  flex-grow: ${props && props.layout && props.layout.grow || 0};
  ${props && props.layout && props.layout.shrink !== undefined ? `flex-shrink:${props.layout.shrink};` : ''};
  `,
};

// shared Button styling
export const secondaryImportanceButton = (props, opacity) => ({
  'background-color': () => {
    if (props.theme.neumorphic && props.theme.tileBackgroundColor) {
      const rgb = hexToRgb(props.theme.tileBackgroundColor);
      return `rgba(${rgb.r},${rgb.g},${rgb.b},${opacity || 1})`;
    }
    return props.theme.dark ? `rgba(255,255,255,${opacity || 0.2})` : `rgba(0,0,0,${opacity || 0.2})`;
  },
  color: props.theme.dark ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.9)',
  'font-size': '14px',
});

export const _ButtonBase = css`
  display: inline-block;
  flex-shrink: 0;
  min-width: 100px;
  ${() => fillMaxWidth()};
  border: none;
  border-radius: 20px;
  padding: 5px;
  margin: 5px;
  line-height: 20px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
